import { API_ROOT, dispatchGetJSONAsync, completeJSONAsync } from './BaseApi';
import appdata from '../Services/appdata';

const ApiOpportunity = () => {
  const getSummary = async (selectedYears) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    const filter = { FYs: _selectedYears };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/opportunity/${company_id}/${company_org_id}/summary${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  const getDetail = async (selectedYears) => {
    let queryParams = '';
    const company_id = appdata.getItem('company').id;
    const company_org_id = appdata.getItem('company_org_id');

    let _selectedYears = selectedYears.slice();
    const allIndex = _selectedYears.indexOf('All');
    if (allIndex > -1) _selectedYears.splice(allIndex, 1);
    const filter = { FYs: _selectedYears };

    queryParams += '?filter=' + JSON.stringify(filter);

    let task = await dispatchGetJSONAsync(
      `${API_ROOT}/opportunity/${company_id}/${company_org_id}/detail${queryParams}`,
    );
    if (!task) {
      return [];
    }
    return await completeJSONAsync(task);
  };

  return {
    getSummary,
    getDetail,
  };
};

export default ApiOpportunity();
